import { theme } from '@gympass/yoga';

export const wellzTheme = {
  sizes: {
    contentWidth: '100%',
    contentHeight: '100%',
    headerHeight: '72',
    avatarWidth: '100',
    avatarHeight: '95',
    avatarCPInfoHeight: '100',
    notesModalWidth: '569',
    notesModalHeight: '581',
    notesInputMessageHeight: '228',
    tabItemLink: '144',
    tabItemWidth: '160',
    progressBarWidth: '242',
    activitiesTableItemWidth: '200',
    deliverContentModalMinWidth: '560',
    assessmentAnswersModalWidth: '724',
    deliverContentLabelHeight: '27',
    textareaMinHeight: '143',
    iframeCPVideoWidth: '510',
    iframeCPVideoHeight: '254',
    sectionPublishedProfileContainerWidth: '609',
    avatarpublishedProfileWidth: '86',
    avatarpublishedProfileHeight: '86',
    hasVideoSpanWidth: '94',
    linearGradientHeader: '64',
    linearGradientLeftMargin: '32',
    linearGradientHeight: '107',
    noContentHeight: '227',
    noProgramWidth: '108',
    messagePadding: '50',
    maxContentWidth: '1024',
    containerWidth: '548',
    containerHeight: '164',
    moreAttentionTooltipMaxWidth: '224',
    sessionHistoryNoDataContentMaxWidth: '277',
    xxhuge: '85',
    sessionHistoryDataCardHeight: '670',
    bigNumberContainerWidth: '302',
    programCardHeaderHeight: '160',
    discoveryBannerInfoWidth: '440',
    pageContentWidth: '808',
    pageContentTitleWidth: '597',
    pinSize: {
      width: '169',
      height: '269',
      widthMobile: '128',
      top: '80',
    },
    smallPinSize: {
      width: '129',
      height: '186',
    },
    programHeader: '200',
    calendarNavigationsButtonsHeight: '35',
    calendarEventContainerWidth: '334',
    calendarEventContainerHeight: '400',
    occasionalTypeDropdownWidth: '240',
    occasionalTimeDropdownWidth: '120',
    occasionalAddButtonWidth: '97',
    textAreaHeight: '52',
  },
  colors: {
    primary: '#710252',
    primaryLight: '#B15991',
    primaryExtraLight: '#F4D3ED',
    secondary: '#FF956B',
    success: '#539775',
    info: '#ffe4b5',
    warning: '#f2c3df',
    error: '#ce3242',
    disabled: '#EEEDF4',
    verseLight: '#ff956b',
    textPrimary: theme.colors.stamina,
    textSecondary: theme.colors.deep,
    textDisabled: '#8f8fae',
    background: theme.colors.clear,
    backgroundLight: '#f9f6f1',
    backgroundProgress: '#f7f3eb',
    inputBackground: theme.colors.white,
    backgroundDarker: '#f6f0e6',
    separatorBackground: '#DBDBE8',
    tableBorder: '#cccce4',
    inputDisabled: '#6B6B78',
    grade: {
      low: '#ACEFCE',
      medium: '#FFC382',
      high: '#E8B0B5',
    },
    elements: {
      disabled: 'rgba(238, 237, 244, .4)',
      disabledRow: 'rgba(238, 237, 244, 0.7)',
    },
    snackbar: {
      attention: '#FCD6C3',
    },
    checkboxDisabled: '#979797',
    checkboxBorderColor: '#8383A3',
    text: {
      disabled: '#6B6B78',
      primary: '#231B22',
    },
    buttery: '#FFC382',
    moduleBorder: '#D7D7E0',
    avatar: '#bdbdbd',
    deepRed: '#CA4808',
  },
  borders: {
    xlarge: '4',
  },
  lineHeights: {
    sessionHistoryTitleLineHeight: '52',
  },
  radii: {
    large: '24',
  },
  spacing: {
    xxxxlarge: '48',
  },
};
